import { ArticleIdsForSocialMetaOps } from '../../types';
import { logErrorArticlePrimaryIdMissing } from '../log.errors';

/**
 * This function is used to select the article id that should be used
 * for reading/writing operations with social metadata.
 * E.g. for a continuation article, the primaryArticleId should be used to read/write comments.
 *
 * @param articleIdsForSocialMetadata - an object with article id and primary article id to select the correct article id
 * for reading/writing social metadata.
 * @returns - the articleId that should be used for reading/writing social metadata.
 * E.g. if the article is a continuation article, the primaryArticleId should be used.
 */
export function getArticleIdForSocialMetadataOps({ id, primaryArticleId }: ArticleIdsForSocialMetaOps) {
    if (!primaryArticleId) {
        logErrorArticlePrimaryIdMissing(id);
    }
    return primaryArticleId;
}
